// extracted by mini-css-extract-plugin
export var quantityInput = "_oz-0";